import { useEffect } from 'react';

/*
 * Probably best to use an immutable url to avoid flickering
 */
export const NavigateToExternalUrl = ({ url }: { url: string }) => {
    useEffect(() => {
        window.location.href = url;
    }, [url]);
    return null;
};
